import qrcode from "qrcode-generator";
import { env } from "./env";

/** Link público do catálogo do laboratório — o mesmo que vai no QR da etiqueta. */
export const linkDoCatalogo = (codigo: string) => `${env.landingUrl}/catalogo/${codigo}`;

/** QR do link em SVG; `margem` em módulos (4 é a zona livre que os leitores esperam no impresso). */
export function qrDoLink(url: string, { celula = 8, margem = 4 } = {}) {
  const qr = qrcode(0, "M");
  qr.addData(url);
  qr.make();
  return qr.createSvgTag({ cellSize: celula, margin: margem, scalable: true });
}

/** Baixa o QR do link em SVG (pra imprimir ou mandar). */
export function baixarQrDoLink(url: string) {
  const blob = new Blob([qrDoLink(url)], { type: "image/svg+xml" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = "qr-do-catalogo.svg";
  a.click();
  URL.revokeObjectURL(a.href);
}
